/**
 * The service worker still runs (it's registered in index.html) and caches
 * the app for offline use, but we no longer surface the "A new version is
 * available — reload" toast. New SWs install silently in the background and
 * take effect on the user's next natural page load (close & reopen the tab,
 * or hard refresh). Per user request — no surprise refreshes mid-set.
 *
 * Kept as a component so re-introducing the toast later is a one-line change
 * in App.js, but for now it renders nothing and registers no listeners.
 */
export default function ServiceWorkerUpdater() {
  return null;
}
